import Vue from 'vue'
import '@/setup/axios'
import NProgress from 'nprogress'

// Interceptors para o NProgress durante as requisições AJAX

// Request interceptor
Vue.axios.interceptors.request.use(config => {
  NProgress.start()
  return config
}, error => {
  return Promise.reject(error)
})

// Response interceptor
Vue.axios.interceptors.response.use(response => {
  NProgress.done()
  return response
}, error => {
  NProgress.done()
  return Promise.reject(error)
})
